'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/promise/lib/done.js
 ** module id = 138
 ** module chunks = 0
 **/